import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Offcanvas, Button } from "react-bootstrap";
import MenuIcon from "../assets/images/icons/menu.png";
import UserIcon from "../assets/images/user-icon.svg";
import WalletIcon from "../assets/images/WalletIcon.png";
import BetIcon from "../assets/images/BetIcon.png";
import AcStatement from "../assets/images/AcStatement.png";
import MoonLight from "../assets/images/moon.svg";
import SunLight from "../assets/images/sunny.svg";
import LogoutIconImg from "../assets/images/logout.png";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../redux/auth/actions";
import { Link } from "react-router-dom";
import BonusImg from "../assets/images/bonus.png";
import refferal from "../assets/images/refferal.png";
import MobLeftbar from "./MobLeftbar";
import GamesSearchModal from "../views/components/GamesSearchModal";
import HomeIcon from "../assets/images/icons/header/home.png";
import HomeIcon3D from "../assets/images/icons/header/home-3dNew.png";
import ExchangeIcon from "../assets/images/icons/header/bats.png";
import ExchangeIcon3D from "../assets/images/icons/header/cricketNew.png";
import LiveDealerIcon from "../assets/images/icons/header/spades.png";
import LiveDealerIcon3D from "../assets/images/icons/header/ace-of-spadesNew.png";
import GameShowIcon from "../assets/images/icons/header/remote.png";
import GameShowIcon3D from "../assets/images/icons/header/gamepadNew.png";
import AviatorIcon3D from "../assets/images/icons/header/lottery3dNew.png";
import AviatorIcon from "../assets/images/icons/header/lottery.png";
import MinesIcon from "../assets/images/icons/header/texas-holdem-poker.png";
import MinesIcon3D from "../assets/images/icons/header/tablegame.png";
import AeSexyIcon from "../assets/images/icons/header/slots.png";
import AeSexyIcon3D from "../assets/images/icons/header/jackpotNew.png";

import AndroidIcon from "../assets/images/icons/header/technology.png";

import { getNotifications } from "../redux/app/actions";
import { AiOutlineClose } from "react-icons/ai";

import DepositIcon from "../assets/images/icons/header/wallet.png";
import SecondaryLeftBar from "./SecondaryLeftBar";
import { useLeftBarHook } from "../hooks/useLeftBarHook";

const HeaderAfterLogin = () => {
  const { user, wallet } = useSelector((state) => state.auth);
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const navigate = useNavigate();
  const handleClose = () => setShow(false);
  const dispatch = useDispatch();
  const { appDetails } = useSelector((state) => state.app);
  const [isClassAdded, setIsClassAdded] = useState(false);
  const [websiteNotifications, setWebsiteNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(true);
  const { isSecondaryLeftBarOpen } = useSelector((state) => state.app);
  const leftBarHook = useLeftBarHook();
  const { pathname } = useLocation();

  useEffect(() => {
    const isClassAddedLocalStorage = localStorage.getItem("isClassAdded");
    if (isClassAddedLocalStorage) {
      setIsClassAdded(true);
      document.body.classList.add("light-theme");
    }
    loadNotifications();
  }, []);

  const toggleClass = () => {
    if (isClassAdded) {
      setIsClassAdded(false);
      localStorage.removeItem("isClassAdded");
      document.body.classList.remove("light-theme");
    } else {
      setIsClassAdded(true);
      localStorage.setItem("isClassAdded", true);
      document.body.classList.add("light-theme");
    }
  };

  const loadNotifications = async () => {
    // get notifications
    const notifications = await getNotifications();
    if (notifications && notifications?.data?.data) {
      setShowNotifications(true);
      setWebsiteNotifications(notifications?.data?.data);
    }
  };

  const isActivePath = (url) => {
    return url === pathname;
  };

  return (
    <>
      {(websiteNotifications.length && showNotifications && (
        <div className="marqu">
          <marquee>
            {websiteNotifications.map((notf, idx) => (
              <label key={idx}>{notf?.content}</label>
            ))}
          </marquee>
          <span onClick={() => setShowNotifications(false)}>
            <AiOutlineClose />
          </span>
        </div>
      )) ||
        null}

      <header className="header afterlogin">
        {isSecondaryLeftBarOpen && <SecondaryLeftBar />}
        <div className="topHead">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex">
                    <Button
                      onClick={() => {
                        // dispatch(toggleSecondaryLeftBarAction());
                        leftBarHook.toggleLeftBar();
                      }}
                      className="MenuBtn">
                      <img src={MenuIcon} alt="MenuIcon" />
                    </Button>

                    <div className="logo">
                      <a href="/sports">
                        <img src={appDetails?.LOGO_URL} alt="Logo" />
                      </a>
                    </div>
                  </div>

                  <div className="headerRight ms-auto ms-xl-0">
                    <ul>
                      <li className="d-md-block d-none">
                        <span>Download App for</span>
                        <img src={AndroidIcon} alt="AndroidIcon" />
                      </li>
                      <div class="divider"></div>
                      <li className="balance">
                        <span> ₹ {wallet?.balance}</span>
                      </li>
                      <div class="divider"></div>
                      <li className="d-md-block d-none">
                        <a href="/gatewaylist" className="deposit">
                          <div className="DepositIcon">
                            <img src={DepositIcon} alt="DepositIcon" />
                          </div>
                          <span>Deposit</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="subHead">
          <ul>
            <li>
              <GamesSearchModal />
            </li>
            <li>
              <a
                href="/sports"
                className={
                  isActivePath("/sports") || isActivePath("/") ? "active" : ""
                }>
                <img src={HomeIcon} alt="home" className="nactv" />
                <img src={HomeIcon3D} alt="home" className="actv" />
                <span>Lobby</span>
              </a>
            </li>
            <li>
              <a
                href="/sportsbook/Inplay"
                className={isActivePath("/sportsbook/Inplay") ? "active" : ""}>
                <img src={ExchangeIcon} alt="exchange" className="nactv" />
                <img src={ExchangeIcon3D} alt="exchange" className="actv" />
                <span>Sports</span>
              </a>
            </li>

            <li>
              <a
                href="/casino-types/casino"
                className={
                  isActivePath("/casino-types/casino") ? "active" : ""
                }>
                <img
                  src={LiveDealerIcon}
                  alt="live dealers"
                  className="nactv"
                />
                <img
                  src={LiveDealerIcon3D}
                  alt="live dealers"
                  className="actv"
                />
                <span>Casino</span>
              </a>
            </li>
            <li>
              <a
                href="/casino-types/miniGames"
                className={
                  isActivePath("/casino-types/miniGames") ? "active" : ""
                }>
                <img src={GameShowIcon} alt="game shows" className="nactv" />
                <img src={GameShowIcon3D} alt="game shows" className="actv" />
                <span>Mini Games</span>
              </a>
            </li>
            <li>
              <a
                href="/casino-types/lotterygames"
                className={
                  isActivePath("/casino-types/lotterygames") ? "active" : ""
                }>
                <img src={AviatorIcon} alt="aviator" className="nactv" />
                <img src={AviatorIcon3D} alt="aviator" className="actv" />
                <span>Lottery</span>
              </a>
            </li>
            <li>
              <a
                href="/casino-types/tablegames"
                className={
                  isActivePath("/casino-types/tablegames") ? "active" : ""
                }>
                <img src={MinesIcon} alt="mines" className="nactv" />
                <img src={MinesIcon3D} alt="mines" className="actv" />
                <span>Table Games</span>
              </a>
            </li>
            <li>
              <a
                href="/casino-types/slotsgames"
                className={
                  isActivePath("/casino-types/slotsgames") ? "active" : ""
                }>
                <img src={AeSexyIcon} alt="aesexy" className="nactv" />
                <img src={AeSexyIcon3D} alt="aesexy" className="actv" />
                <span>Slots</span>
              </a>
            </li>
          </ul>
        </div>

        <Offcanvas
          className="user_section"
          show={show}
          onHide={handleClose}
          placement={"end"}>
          <Offcanvas.Header closeButton="closeButton" closeVariant="white">
            <Offcanvas.Title>
              <div className="d-flex">
                <div className="profile-img">
                  <img src={UserIcon} alt="User Icon" />
                </div>
                <div className="user-info">
                  <Link className="user_name" to="/profile">
                    {user?.mstruserid}
                  </Link>
                  <p>{user?.mobileno}</p>
                </div>
              </div>
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="container upperbalnace">
              <div className="row">
                <div className="col-6">
                  <div className="balance mb-4">
                    <img src={WalletIcon} alt="wallet" />
                    Balance
                  </div>
                </div>
                <div className="col-6">
                  <div className="balance-amount mb-4"> {wallet?.balance}</div>
                </div>
                {/* <div className="col-12">
                  <div className="non_cash_balance">
                    <h6 className="non_cash_balance_heading">
                      <span>
                        <strong> Bonus</strong> <small>Non-Cash-Balance </small>{" "}
                      </span>
                      <span>
                        <strong>{wallet?.coins}</strong>
                      </span>
                    </h6>
                  </div>
                </div> */}
                <div
                  className="col-6"
                  onClick={() => {
                    navigate("/withdraw");
                  }}>
                  <Button variant="" className="btn_withdraw w-100">
                    Withdraw
                  </Button>
                </div>
                <div
                  className="col-6"
                  onClick={() => {
                    navigate("/gatewaylist");
                  }}>
                  <Button variant="primary" className="btn_primary w-100">
                    Deposit
                  </Button>
                </div>
              </div>
            </div>
            <ul className="menu-items">
              {/* <li>
                <a href="/profile">
                  <FaRegUserCircle />
                  <span>Profile</span>
                </a>
              </li> */}
              <li>
                <a href="/mybets">
                  <img src={BetIcon} alt="my bet" />
                  <span>My Bets</span>
                </a>
              </li>
              <li>
                <a href="/bonus" className="img_size">
                  <img src={BonusImg} />
                  <span className="bonus-space">Bonus</span>
                </a>
              </li>
              <li>
                <a href="/referral" className="img_size">
                  <img src={refferal} />

                  <span className="bonus-space">Referral</span>
                </a>
              </li>
              <li>
                <a href="/cashier">
                  <img src={AcStatement} alt="account statement" />
                  <span>Account Statement</span>
                </a>
              </li>

              <li
                onClick={() => {
                  dispatch(logoutUser(true));
                }}>
                <a href="#">
                  {/* <LogoutIcon /> */}
                  <img src={LogoutIconImg} />
                  <span>Sign Out</span>
                </a>
              </li>
            </ul>

            <div className="theme-btn">
              <button type="button" className="btn" onClick={toggleClass}>
                <img src={SunLight} alt="sun" className="light_theme" />
                <img src={MoonLight} alt="moon" className="dark_theme" />
              </button>
            </div>
          </Offcanvas.Body>
        </Offcanvas>

        {show1 && <MobLeftbar className="d-block d-md-none" />}
      </header>
    </>
  );
};

export default HeaderAfterLogin;
